"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _reactRedux = require("react-redux");
var _APSelect = _interopRequireDefault(require("../common/APSelect"));
var _config = _interopRequireDefault(require("../../config"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./FMSGatewayComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('fms-gateway');
var FMSGatewayComponent = function FMSGatewayComponent() {
  var _config$FuturesTradin, _config$FuturesTradin2;
  var _useTranslation = (0, _reactI18next.useTranslation)('auth'),
    t = _useTranslation.t;

  // Get the gateway value from form state
  var currentGateway = (0, _reactRedux.useSelector)(function (state) {
    var _state$form;
    return (_state$form = state.form) === null || _state$form === void 0 || (_state$form = _state$form.login) === null || _state$form === void 0 || (_state$form = _state$form.values) === null || _state$form === void 0 ? void 0 : _state$form.gateway;
  }) || '';

  // Only show FMS dropdown when the actual current gateway includes 'localhost'
  var shouldShowFMSDropdown = currentGateway && currentGateway.includes('localhost');
  if (!shouldShowFMSDropdown) {
    return null;
  }
  var fmsGateways = Array.isArray((_config$FuturesTradin = _config["default"].FuturesTrading) === null || _config$FuturesTradin === void 0 ? void 0 : _config$FuturesTradin.gateway) ? _config["default"].FuturesTrading.gateway : [(_config$FuturesTradin2 = _config["default"].FuturesTrading) === null || _config$FuturesTradin2 === void 0 ? void 0 : _config$FuturesTradin2.gateway].filter(Boolean);

  // Get previously selected FMS gateway from localStorage or use first one
  var storedFMSGateway = localStorage.getItem('fmsGateway');
  var defaultFMSGateway = storedFMSGateway && fmsGateways.includes(storedFMSGateway) ? storedFMSGateway : fmsGateways[0];
  var fmsOptions = fmsGateways.map(function (gateway) {
    return {
      value: gateway,
      label: gateway
    };
  });
  return /*#__PURE__*/_react["default"].createElement(_APSelect["default"], {
    name: "fmsGateway",
    label: "".concat(t('Select FMS Gateway'), ":"),
    showTriangles: true,
    customClass: baseClasses(),
    options: fmsOptions,
    defaultValue: defaultFMSGateway,
    onSelect: function onSelect(value) {
      return localStorage.setItem('fmsGateway', value);
    }
  });
};
var _default = exports["default"] = FMSGatewayComponent;